import React, { Component, Fragment } from "react";
import {
	Button,
	Checkbox,
	Form,
	Divider,
	Table,
	Row,
	Popconfirm,
	Spin
} from "antd";
import styles from "../index.module.less";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import AddProxiesDialog from "./AddProxiesDialog";

const FormItem = Form.Item;

var statusRenderer = function(params) {
	if (params.value == "SUCCESS") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(17, 119, 51);">Success</div>';
	} else if (params.value == "FAILED") {
		return '<div data-show="true" class="ant-tag ant-tag-has-color" style="background-color: rgb(217, 33, 32);">Failed</div>';
	} else if (params.value == "NONE") {
		return "";
	} else if (params.value == "RUNNING") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(16, 142, 233);">Running</div>';
	} else {
		return "<span></span>";
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@inject("rootStore")
@observer
class ProxyForm extends Component {
	constructor(props) {
		super(props);
		this.updateProxyDisposer = null;
		this.deleteProxiesDisposer = null;
	}

	onGridReady = params => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const ui = optionsStore.ui;
		this.updateProxyDisposer = autorun(() => {
			if (ui.updatedProxy != null) {
				const proxy = ui.updatedProxy;
				const existingProxy = this.gridApi.getRowNode(
					proxy.id.address + "_" + proxy.id.port
				);
				if (existingProxy != null) {
					this.gridApi.updateRowData({
						update: [proxy]
					});
				} else {
					this.gridApi.updateRowData({
						add: [proxy]
					});
				}
			}
		});

		this.deleteProxiesDisposer = autorun(() => {
			if (ui.deletedProxies.length != 0) {
				const proxies = ui.deletedProxies.map(function(proxy) {
					return {
						id: {
							address: proxy.address,
							port: proxy.port
						}
					};
				});
				this.gridApi.updateRowData({
					remove: proxies
				});
			}
		});
	};

	componentWillUnmount() {
		if (this.updateProxyDisposer != null) {
			this.updateProxyDisposer();
		}
		if (this.deleteProxiesDisposer != null) {
			this.deleteProxiesDisposer();
		}
	}

	createColumnDefs() {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "IP Address",
					field: "address",
					headerCheckboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true,
					checkboxSelection: true,
					suppressMenu: true
				},
				{
					headerName: "Port",
					field: "port",
					width: 267,
					suppressMenu: true
				},
				{
					headerName: "Status",
					field: "proxyStatus",
					width: 150,
					suppressMenu: true,
					cellClass: function() {
						return "alphabet";
					}
				}
			],
			groupDefaultExpanded: -1,
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	addProxies = proxies => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.remoteAddProxies(proxies);
	};

	showAddProxiesDialog = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.showAddProxiesDialog();
	};

	hideddProxiesDialog = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.hideAddProxiesDialog();
	};

	deleteProxies = () => {
		const selectedRows = this.gridApi.getSelectedRows();
		const selectedProxies = selectedRows.map(function(row) {
			return {
				address: row.address,
				port: row.port
			};
		});

		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.remoteDeleteProxies(selectedProxies);
	};

	checkProxies = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.checkProxies();
	};

	stopCheckingProxies = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.stopCheckingProxies();
	};

	doNothing = () => {
		// console.log("Do nothing");
	};

	render() {
		const gridDefs = this.createColumnDefs();

		const {
			rootStore: { optionsStore }
		} = this.props;
		const ui = optionsStore.ui;

		const proxies = optionsStore.proxies.slice();
		let addProxiesDialog = (
			<AddProxiesDialog
				ui={optionsStore.ui}
				addProxies={this.addProxies}
				hideDialog={this.hideddProxiesDialog}
			/>
		);

		let spinning = ui.deletingProxies == true;

		const proxyMonitorState = optionsStore.proxyMonitorState;
		let checkProxyButtonName = "Check";

		var checkProxyButtonClick = this.doNothing;

		switch (proxyMonitorState) {
			case "NEW":
				checkProxyButtonName = "Check";
				checkProxyButtonClick = this.checkProxies;
				break;
			case "CHECKING":
				checkProxyButtonName = "Stop checking";
				checkProxyButtonClick = this.stopCheckingProxies;
				break;
			case "STOPPING":
				checkProxyButtonName = "Stopping";
				break;
		}

		return (
			<Fragment>
				{addProxiesDialog}
				<Spin spinning={spinning}>
					<Form className={styles.rxform}>
						<FormItem>
							{this.props.form.getFieldDecorator("useProxyForPosting", {
								valuePropName: "checked"
							})(<Checkbox>Use Proxy</Checkbox>)}
						</FormItem>
						<FormItem>
							<Button type="primary" onClick={this.showAddProxiesDialog}>
								Add
							</Button>
							<Divider type="vertical" />
							<Popconfirm
								title="Do you really want to delete selected proxies?"
								onConfirm={this.deleteProxies}
							>
								<Button type="primary">Delete</Button>
							</Popconfirm>
							<Divider type="vertical" />
							<Button
								type="primary"
								disabled={proxyMonitorState == "STOPPING"}
								onClick={checkProxyButtonClick}
							>
								{checkProxyButtonName}
							</Button>
						</FormItem>
					</Form>
					<div
						style={{
							boxSizing: "border-box",
							height: window.screen.height * 3 / 4,
							width: "100%"
						}}
						className="ag-theme-balham"
					>
						<AgGridReact
							id="myGrid"
							columnDefs={gridDefs.columnDefs}
							enableColResize={true}
							enableSorting={true}
							groupSelectsChildren={true}
							groupDefaultExpanded={gridDefs.groupDefaultExpanded}
							autoGroupColumnDef={gridDefs.autoGroupColumnDef}
							defaultColDef={gridDefs.defaultColDef}
							rowData={proxies}
							enableRangeSelection={true}
							rowSelection={gridDefs.rowSelection}
							suppressRowClickSelection={true}
							onRowSelected={this.onRowSelected}
							onSelectionChanged={this.onSelectionChanged}
							getRowNodeId={data => {
								return data.id.address + "_" + data.id.port;
							}}
							onSortChanged={e => {
								// console.log(e.api.getSortModel());
							}}
							deltaRowDataMode={true}
							onGridReady={this.onGridReady}
						/>
					</div>
				</Spin>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class ProxyTab extends Component {
	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;

		return {
			useProxyForPosting: Form.createFormField(options.useProxyForPosting)
		};
	};
	render() {
		return (
			<ProxyForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
			/>
		);
	}
}

export default ProxyTab;
